window.Plugin = {
	
	promptActivate: function(name){
		var message = Loc.g("La fonctionnalité")+" : <strong>" + name + "</strong> "+Loc.g('est désactivée')+". <br /><br /> "+Loc.g("Voulez-vous être redirigé vers vos préférences afin de l'activer ?");
		var options = {
			resizable	: false,
			noclose		: true,
			type		: "warning",
			title		: Loc.g("Activation de fonctionnalités"),
			buttons		: [
					{
						text : Loc.g('Non'),
						click : function(){$(this).dialog("close");}
					},
					{
						text : Loc.g('Oui'),
						click : function(){Utils.relocate('?_f=store')}
					}
				]
		};
		MyWindow.alert(message, options);
	},
	
	manageAccess : function(plugin_id){
		var options = {
			resizable	: false,
			noclose		: true,
			type		: "warning",
			title		: Loc.g("Gestion de l'accès au plugin"),
			buttons		: [
						{text : Loc.g('Annuler'),click : function(){$(this).dialog("close");}},
						{text : Loc.g('Enregistrer'),click : function(){$('#prefsPluginAccess').submit();}}
					],
			callback : function(){
				var formId = "prefsPluginAccess";
		
				var options = {
					success:function(data){
						MyWindow.close();
					}, 
					dataType:"json"
				};
				
				var params = {action: 'recordAccess'};
				MyForm.prepare(formId, "storeApps&"+$.param(params), options, true);
				MyFacture.initEvent();
			}
		};
		
		MyWindow.load('storeApps', {action:'accessForm', plugin_id:plugin_id}, options, true);
		
	},
	
	activateModule : function(message) {
		Push.error(message);
	}
};